import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EnvironmentMonitorComponent } from './pages/environment-monitoring/environment-monitor.component';
import { StockInfoSearchComponent } from './pages/stock-info-search/stock-info-search.component';
import { StockMaintenanceComponent } from './pages/stock-maintenance/stock-maintenance.component';
import { StockSkuSearchComponent } from './pages/stock-sku-search/stock-sku-search.component';
import { ExpiredControlComponent } from '../transport-operation/pages/expired-control/expired-control.component';
import { AuthGuard } from 'src/app/core/guards/auth.guard';

const routes: Routes = [
  {
      path: '',
      canActivateChild: [AuthGuard],
      children:[
      { 
        path: 'StockMaintenance',
        component: StockMaintenanceComponent,
      },
      {
        path: 'EnvironmentMonitor',
        component: EnvironmentMonitorComponent,
      },
      {
        path: 'StockSKUSearch',
        component: StockSkuSearchComponent,
      },
      {
        path: 'StockInfoSearch',
        component: StockInfoSearchComponent,
      },
      {
        path: 'SpecialInventoryControl',
        loadChildren: () =>
          import(
            './pages/special-inventory-control/special-inventory-control.module'
          ).then((m) => m.SpecialInventoryControlModule),
      },
      {
        path: 'ExpiredControl',
        component: ExpiredControlComponent,
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StockRoutingModule {}
